import locale from 'date-fns/locale/sv';
export default locale;
